import { useEffect } from 'react';

import { PostMessageAction, sendMessage } from '@/lib/postMessage';
import { stepStore } from '@/stores/steps';

export const useStepChangeBroadcaster = () => {
  useEffect(() => {
    const unsubscribe = stepStore.subscribe(
      state => state.contentHistory,
      contentHistory => {
        if (contentHistory.length === 0) {
          return;
        }

        const lastStep = contentHistory[contentHistory.length - 1];

        if (lastStep.origin === 'setSteps') {
          return;
        }

        sendMessage(PostMessageAction.CURRENT_STEP_CHANGED, {
          currentStep: stepStore.getState().stepData,
          contentHistory,
          stepOrigin: lastStep.origin
        });
      }
    );

    return unsubscribe;
  }, []);
};
